/**
 * Quantas requisições estão no ar, agora.
 *
 * Existe para responder a única pergunta que a interface não sabia responder: *"travou ou está
 * trabalhando?"*. Paginar um resultado, tirar um chip da busca, abrir um nó do grafo — tudo isso
 * ia ao servidor sem a tela dizer nada, e uma espera silenciosa de dois segundos é indistinguível
 * de um clique que não pegou. O operador clica de novo, e aí sim faz duas vezes o que queria uma.
 *
 * Fica no CLIENTE HTTP, e não em cada tela: é o único ponto por onde tudo passa. Marcar
 * "carregando" à mão em cada chamada é o tipo de disciplina que funciona por três semanas — a
 * requisição nova de amanhã simplesmente não teria feedback, e ninguém notaria até um operador
 * reclamar.
 *
 * Não é um `useState` porque quem conta é o módulo `api`, que não é componente. É um contador com
 * assinantes — o mínimo que resolve, sem trazer uma biblioteca de estado para isto.
 */

type Ouvinte = (quantas: number) => void;

let emVoo = 0;
const ouvintes = new Set<Ouvinte>();

function avisar() {
  for (const o of ouvintes) o(emVoo);
}

/** O cliente HTTP chama isto ao começar e devolve a função que encerra. */
export function comecou(): () => void {
  emVoo += 1;
  avisar();
  let encerrado = false;
  return () => {
    // Idempotente: um `finally` que rode duas vezes não pode deixar o contador negativo e a barra
    // acesa para sempre.
    if (encerrado) return;
    encerrado = true;
    emVoo = Math.max(0, emVoo - 1);
    avisar();
  };
}

export function assinar(o: Ouvinte): () => void {
  ouvintes.add(o);
  o(emVoo);
  return () => ouvintes.delete(o);
}

export const quantasEmVoo = (): number => emVoo;
